<h2 mat-dialog-title>Удаление вопроса</h2>
<div mat-dialog-content>
  <p>Удалить вопрос?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Отмена</button>
  <button mat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Удалить
  </button>
</div>
